var React = require('react');

function Person (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.41 8.624a3.41 3.41 0 11-6.82 0 3.41 3.41 0 016.82 0z","fill":"#4541E3","key":0}),React.createElement("path",{"d":"M11 .55C5.236.55.55 5.236.55 11c0 5.764 4.686 10.45 10.45 10.45 5.764 0 10.45-4.686 10.45-10.45C21.45 5.236 16.764.55 11 .55zm5.588 16.896v-.418a4.028 4.028 0 00-4.027-4.026H9.416A4.028 4.028 0 005.39 17.03v.417A8.565 8.565 0 012.464 11c0-4.708 3.827-8.536 8.536-8.536 4.707 0 8.536 3.828 8.536 8.536a8.508 8.508 0 01-2.948 6.446z","fill":"#4541E3","key":1})]);
}

Person.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = Person;

Person.default = Person;
